// extracted by mini-css-extract-plugin
module.exports = {"saveChangesButton":"EditFormDataPopup_saveChangesButton__84vFj","cardsForm":"EditFormDataPopup_cardsForm__3mYfK"};